module.exports = __webpack_public_path__ + "img/secondary_10x1_z18.8c1b5b71.svg";